// Copyright (c) 2026 Joshua S. Plaza. All rights reserved.

import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Container, Paper, Typography } from '@mui/material';
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import PageWrapper from '../components/PageWrapper';

const AuthLayout = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: 'linear-gradient(135deg, #1A365D 0%, #0F2440 100%)',
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: { xs: 2, sm: 4 },
        }}
      >
        <Container maxWidth="sm">
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2, sm: 3, md: 4 },
              borderRadius: 2,
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
              border: '1px solid',
              borderColor: 'divider',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                mb: 3,
              }}
            >
              <Box
                component="img"
                src="/logo.png"
                alt="RNHS Logo"
                sx={{
                  width: { xs: 60, sm: 80 },
                  height: { xs: 60, sm: 80 },
                  objectFit: 'contain',
                  mb: 2,
                }}
              />
              <Typography variant="h4" component="h1" fontWeight="bold" color="primary">
                RNHS Portal
              </Typography>
              <Typography variant="body2" color="text.secondary">
                RNHS
              </Typography>
            </Box>
            <PageWrapper>
              <Outlet />
            </PageWrapper>
          </Paper>
          <Typography
            variant="body2"
            align="center"
            sx={{ mt: 3, color: 'white' }}
          >
            School Management System
          </Typography>
        </Container>
      </Box>
      <Footer variant="auth" />
      <BackToTop />
    </Box>
  );
};

export default AuthLayout;
